import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Icon, Loader, Helper, PowerTable, Belt } from 'Components';
import AppContext from 'src/AppContext';
import './SummaryTable.css';

const SummaryTable = (props) => {
  const hasData = props.data.length !== 0;
  return (
    <Fragment>
      <div className="summary-table">
        {props.isLoading && <Loader isSolidWhite />}
        <div className="summary-table__header">
          <Belt>
            <h2>{props.t(`common:${props.title}`)}</h2>
            {/* hasData &&
            <Helper placement="bottom-left" text={props.t('tutorials:dashboardOverview.7')}>
              <StandaloneIcon
                className="summary-table__gear"
                onClick={() => props.setAppState({
                  settingTableCode: props.viewCode,
                })}
                icon="settings"
              />
            </Helper>
            */}
            <Helper placement="bottom-left" text={props.t('tutorials:dashboardOverview.15')}>
              {hasData &&
              <Link to={`/${props.code}`}>
                {props.t('common:view more')}{'\u00A0'}
                <Icon icon="chevron_right" />
              </Link>
              }
            </Helper>
          </Belt>
        </div>
        <div className="summary-table__table">
          {hasData &&
          <PowerTable
            userName={props.userName}
            keyPairs={props.keyPairs}
            keys={props.keys.slice(0, 4)}
            data={props.data}
            setAppState={props.setAppState}
            setPageState={props.setPageState}
            code={props.code}
            viewCode={props.viewCode}
            menuOptions={props.menuOptions}
            rowRules={props.rowRules}
            powerTableIndex={props.powerTableIndex}
            onOptionClick={props.onOptionClick}
            onPinClick={props.onPinClick}
            isSupplyWarningON={props.isSupplyWarningON}
            isTemplateWarningON={props.isTemplateWarningON}
            isSubmissionWarningON={props.isSubmissionWarningON}
            isPrepaid={props.isPrepaid}
          />
          }
          { !hasData && !props.isLoading &&
          <div className="summary-table__table__placeholder-description">{props.description}</div>
          }
        </div>
      </div>
    </Fragment>
  );
};

SummaryTable.propTypes = {
  title: PropTypes.string,
  keys: PropTypes.arrayOf(PropTypes.string),
  keyPairs: PropTypes.shape({}),
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  rowRules: PropTypes.func,
  userName: PropTypes.string,
  code: PropTypes.string,
  viewCode: PropTypes.string,
  setAppState: PropTypes.func,
  description: PropTypes.shape({}),
  t: PropTypes.func,
  setPageState: PropTypes.func,
  menuOptions: PropTypes.arrayOf(PropTypes.shape({})),
  powerTableIndex: PropTypes.number,
  onOptionClick: PropTypes.func,
  onPinClick: PropTypes.func,
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
};

SummaryTable.defaultProps = {
  data: [],
  keys: [],
  keyPairs: {},
};

export default withTranslation()(props => (
  <AppContext.Consumer>
    {context => (
      <SummaryTable
        {...props}
        setAppState={context.setAppState}
      />)}
  </AppContext.Consumer>
));



// WEBPACK FOOTER //
// ./src/components/SummaryTable/SummaryTable.jsx